import { Field } from 'formik';
import * as React from 'react';
import { NumericFormat } from 'react-number-format';

import { CurrencyFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function CurrencyField(props: CurrencyFieldProps) {
    const {
        fieldSize,
        name,
        label,
        placeholder,
        disabled,
        currencySymbol,
        maxLength,
        errors,
        currencyDecimalPoint
    } = props;

    const classes = muiStyles(props);
    const symbol = currencySymbol ?? '$';

    return (
        <Field
            name={name}
            type='text'
        >
            {({ field, form }) => (
                <div className={classes.field}>
                    <label
                        className={fieldSize === 'large' ? classes.inputLabelLarge : classes.inputLabel}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                    <div className={classes.inputContainer}>
                        <NumericFormat
                            {...field}
                            allowNegative={false}
                            autoComplete='off'
                            className={fieldSize === 'large' ? classes.currencyInputLarge : classes.textInput}
                            decimalScale={currencyDecimalPoint ?? 2}
                            disabled={disabled}
                            key={`${currencySymbol}_CurrencyField`}
                            maxLength={maxLength || 40}
                            name={name}
                            onValueChange={(values) => {
                                if (!form.touched[name]) {
                                    form.setFieldTouched(name, true);
                                }
                                field.onChange({
                                    target: {
                                        name,
                                        value: values.formattedValue
                                    }
                                });
                            }}
                            placeholder={placeholder === 'USD' ? '$' : placeholder}
                            prefix={/^[A-Za-z]+$/.test(symbol) ? symbol + ' ' : symbol}
                            thousandSeparator=','
                        />
                    </div>
                    <ErrorMessage
                        error={errors[field.name]}
                        field={field}
                        form={form}
                    />
                </div>
            )}
        </Field>
    );
}